// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_c98ca7d","tooltip":"_8b155e3","tooltipWrapper":"_ffca1a4"};